module.exports = __webpack_public_path__ + "f5556dca8b668e4122c2be4e6484148d.fbx";